"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const darkcirclesskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-darkcirclesskin` : '') + (description ? ` desc-darkcirclesskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-darkcirclesskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-darkcirclesskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.72 17.1a.75.75 0 0 1 .77 1.28l-.02.01-.05.03a24.1 24.1 0 0 1-.9.51c-.61.33-1.46.77-2.44 1.21-1.94.87-4.48 1.81-6.65 1.89-2.39.08-5.22-.87-7.38-1.78a39.32 39.32 0 0 1-3.74-1.82l-.06-.03-.01-.01a.75.75 0 0 1 .74-1.3H2l.05.04a22.82 22.82 0 0 0 .96.51c.66.34 1.57.79 2.62 1.23 2.14.9 4.7 1.73 6.75 1.66 1.86-.06 4.17-.9 6.08-1.76a37.24 37.24 0 0 0 3.02-1.54l.18-.1.05-.03h.01Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.67 14.13a.75.75 0 0 1 .93 1.17l-.06.05-.02.01-.05.04a19.23 19.23 0 0 1-.9.6c-.6.38-1.44.9-2.42 1.41-1.92 1.02-4.48 2.13-6.72 2.22-2.45.09-5.3-1.02-7.45-2.09a36.01 36.01 0 0 1-3.72-2.13l-.06-.04-.01-.01a.75.75 0 0 1 .84-1.24h.01l.05.04a19.43 19.43 0 0 0 .96.6c.65.4 1.55.92 2.6 1.44 2.12 1.05 4.67 2 6.73 1.93 1.87-.07 4.17-1.03 6.07-2.04a33.87 33.87 0 0 0 2.99-1.8l.17-.12.05-.03v-.01h.01Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.05 5.74a3.6 3.6 0 1 1 0 7.2 3.6 3.6 0 0 1 0-7.2Zm0 2.4a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.06 2c4.02-.06 8.04 2.54 10.7 5.26l.52.54a2.4 2.4 0 0 1 0 3.2v.01c-2.58 2.84-6.86 5.87-11.22 5.8h-.02c-4.36.07-8.64-2.96-11.22-5.8a2.4 2.4 0 0 1 0-3.2C3.46 4.9 7.75 1.93 12.04 2l.02-.01Zm-.01 1.94a5.4 5.4 0 1 0 0 10.8 5.4 5.4 0 0 0 0-10.8Zm-5.04.9c-1.93 1-3.7 2.46-5.08 3.97a.9.9 0 0 0 0 1.2 18.84 18.84 0 0 0 5.35 4.1A6.75 6.75 0 0 1 7 4.84Zm10.08 0a6.75 6.75 0 0 1 1.71 4.5v.25a6.75 6.75 0 0 1-1.98 4.52 18.74 18.74 0 0 0 5.35-4.1.9.9 0 0 0 0-1.2 18.88 18.88 0 0 0-5.08-3.96Z",
    fill: "#232323"
  }));
};
var _default = exports.default = darkcirclesskin;